import { CreateOrUpdateThreshold, ThresholdByProductId } from "@dto/threshold/threshold.dto";
import { ThresholdsListFiltersDto } from "@dto/threshold/thresholds-list-filters.dto";
import {createAction, props} from "@ngrx/store";
import { RateType } from "@type/rate.type";

const state = '[Thresholds List]';

export const initFilters = createAction(
  `${state} Init filters`,
  props<{filters: ThresholdsListFiltersDto}>()
);

// ---- load thresholds ----
export const loadThresholds = createAction(
  `${state} Load thresholds`,
  props<{ productIds: string[] }>()
);
export const loadThresholdsSuccess = createAction(
  `${state} Load thresholds success`,
  props<{ thresholds: ThresholdByProductId }>()
);
export const loadThresholdsFailure = createAction(
  `${state} Load thresholds failure`,
  props<{ error: string }>()
);

// ---- change thresholds filters ----
export const changeThresholdsFilters = createAction(
  `${state} Change thresholds filter`,
  props<{ filters: ThresholdsListFiltersDto }>()
);
export const changeThresholdsFiltersSuccess = createAction(
  `${state} Change thresholds filter success`,
  props<{ filters: ThresholdsListFiltersDto, eventTypeData: string[], indicators: RateType [] }>()
);
export const changeThresholdsFiltersFailure = createAction(
  `${state} Change thresholds filter failure`,
  props<{ error: string, filters: ThresholdsListFiltersDto, eventTypeData: string[] , indicators: RateType []}>()
);

// ---- change thresholds ----
// ADD or UPDATE thresholds
export const upsertNewThresholds = createAction(
  `${state} Create or update new thresholds`,
  props<{ newThreshold: CreateOrUpdateThreshold}>()
);
export const upsertNewThresholdsSuccess = createAction(
  `${state} Create or update new thresholds success`,
  props<{ newThreshold: CreateOrUpdateThreshold}>()
);
export const upsertNewThresholdsFailure = createAction(
  `${state} Create or update new thresholds failure`,
  props<{ error: string, newThreshold: CreateOrUpdateThreshold }>()
);

// DELETE thresholds
export const deleteThresholds = createAction(
  `${state} Delete thresholds`,
  props<{ productId: string, eventType: string, indicatorName: RateType, triggerType: string }>()
);
export const deleteThresholdsSuccess = createAction(
  `${state} Delete thresholds success`,
  props<{ productId: string, eventType: string, indicatorName: RateType, triggerType: string }>()
);
export const deleteThresholdsFailure = createAction(
  `${state} Delete thresholds failure`,
  props<{ error: string, productId: string, eventType: string, indicatorName: RateType, triggerType: string }>()
);

// UPDATE PRIORITY
export const updateThresholdPriority = createAction(
  `${state} Update threshold priority`,
  props<{ productId: string, eventType: string, priority: number }>()
);
export const updateThresholdPrioritySuccess = createAction(
  `${state} Update threshold priority success`,
  props<{ productId: string, eventType: string, priority: number }>()
);
export const updateThresholdPriorityFailure = createAction(
  `${state} Update threshold priority failure`,
  props<{ error: string, productId: string, eventType: string, priority: number }>()
);